const settingsEn = {
    action: require('../../lang/en/settings/Action').default,
    module: require('../../lang/en/settings/Module').default,
    userRole: require('../../lang/en/settings/UserRole').default,
    permission: require('../../lang/en/settings/Permission').default,
    companyPermission: require('../../lang/en/settings/CompanyPermission').default,
    userPermission: require('../../lang/en/settings/UserPermission').default,
};

export default settingsEn;